
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Popup extends Vue {
  public show: boolean = false;

  private escKeyDown?: Function;

  mounted() {
    window.addEventListener('keydown', this.handleEscKey);
  }

  // 组件销毁钩子
  destroyed() {
    /* eslint-disable prefer-destructuring */
    const parentNode: any = this.$el.parentNode;
    parentNode.removeChild(this.$el);
    window.removeEventListener('keydown', this.handleEscKey);
  }

  handleEscKey(event: KeyboardEvent) {
    if (event.keyCode === 27 && this.escKeyDown) this.escKeyDown();
  }
}
